import { createSlice } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import * as swissknife from 'up.lib.js.swissknife';
import { InputLocalizationType } from '~src/domains/common/types/forms';

const inputStateTemplate = {
  value: '',
  label: '',
  isValid: true,
  isFocused: false,
  errorMessage: '',
  isHidden: null,
  isDisabled: null,
  validityConfig: [],
  postProcess: null,
};

export const createDefaultFormMeta = (inputs: any) => {
  const formMeta: { [k: string]: any } = {};

  for (let i = 0; i < inputs.length; i++) {
    const [id, defaultValues] = inputs[i];

    formMeta[id] = {};
    swissknife.deepAssignObj(formMeta[id], inputStateTemplate);

    if (defaultValues && swissknife.isObj(defaultValues)) {
      swissknife.deepAssignObj(formMeta[id], defaultValues);
    }
  }

  return formMeta;
};

export const updateFormMeta =
  (
    inputs: {
      [key: string]: InputLocalizationType;
    },
    formActions: any,
  ) =>
  (dispatch: Function) => {
    for (const name in inputs) {
      const { label, validity, postProcess } = inputs[name];

      batch(() => {
        dispatch(formActions.updateInputIsValid({ name, msg: '' }));
        dispatch(
          formActions.registerInputLabel({
            name,
            value: label,
          }),
        );
        dispatch(
          formActions.registerValidityConfig({
            name,
            value: validity,
          }),
        );

        if (postProcess) {
          dispatch(
            formActions.registerPostProcess({
              name,
              value: postProcess,
            }),
          );
        }
      });
    }
  };

export const createFormMetaSlice = (
  name: string,
  formMetaDefault: any,
  additionalReducers: object = {},
) =>
  createSlice({
    name: name,
    initialState: formMetaDefault,
    reducers: {
      ...additionalReducers,
      updateInputValue: (state: any, action) => {
        state[action.payload.name].value = action.payload.value;
        state[action.payload.name].isValid = null;
      },
      updateInputHidden: (state: any, action) => {
        state[action.payload.name].isHidden = action.payload.value;
      },
      updateInputDisabled: (state: any, action) => {
        state[action.payload.name].isDisabled = true;
      },
      updateInputIsValid: (state: any, action) => {
        state[action.payload.name].isValid = !action.payload.msg;
        state[action.payload.name].errorMessage = action.payload.msg;
      },
      registerInputLabel: (state: any, action) => {
        state[action.payload.name].label = action.payload.value;
      },
      registerValidityConfig: (state: any, action) => {
        if (state[action.payload.name]) {
          state[action.payload.name].validityConfig = action.payload.value;
        }
      },
      registerPostProcess: (state: any, action) => {
        state[action.payload.name].postProcess = action.payload.value;
      },
    },
  });
